module.exports = __webpack_public_path__ + "fa-regular-400.d1d7e3b4c219fde0f737.woff";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/@fortawesome/fontawesome-free/webfonts/fa-regular-400.woff
// module id = ../../../../@fortawesome/fontawesome-free/webfonts/fa-regular-400.woff
// module chunks = 2